import React, { Fragment, useEffect, useState } from 'react'
import NavigationHeder from '../../Navigations/NavigationHeder';
import LinkBtn from '../../inc/LinkBtn';
import Button from '../../inc/Button';
import SimpleLoading from '../../Loading/SimpleLoading';
import { areObjectsDifferent, getOnlyChangedValuesForApiPayload, getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import Api from '../../../inc/Api';
import Settings from '../../../inc/Settings';
import FieldsRenderer from '../../Purchase Orders Internal/Edit PO/FieldsRenderer';
import Collapse from '../../inc/Collapse';
import { useParams } from 'react-router-dom';
import FormValidator from '../../../inc/FormValidator';
import Helper from '../../../inc/Helper';
import MasterComponentWraper from '../../Backend/MasterComponentWraper';
import { connect } from 'react-redux';

let defaultAppMasterFormsObject = null;
const AppMasterFormsDetailView = () => {
    const [appMasterFormsData, setAppMasterFormsData] = useState({});

    const { id } = useParams();

    const [loading, setLoading] = useState(true); 
   
    let getByIdApiCall = false; 

    useEffect(() => { 
        getAppMasterFormsById();
    }, [])
  
    let validator; 

    const validationConfigure = () => {
        let fieldConfig = [
            { name: "app_name", displayName: "App name", types: ["Required"] },
            { name: "app_description", displayName: "App description", types: ["Required"] },
            { name: "base_url", displayName: "Base URL", types: ["Required"] },
            { name: "login_payload", displayName: "Login payload", types: ["Required"] }
        ];

        if(!validator) {
            validator = new FormValidator(fieldConfig)
        }
    }

    validationConfigure();

    const getAppMasterFormsById = () => { 
        if(getByIdApiCall) return;

        getByIdApiCall = true;
        setLoading(true);

        let api = Api
        api.setUserToken()
        api.axios().get(Settings.apiAppUrl+`/update/${id}/`,{}).then(function(res) {
            if(res?.status === 200){ 
                setAppMasterFormsData({...res?.data, login_payload: res?.data.login_payload ? JSON.stringify(res?.data?.login_payload) : ""});
                defaultAppMasterFormsObject = {...res?.data, login_payload: res?.data.login_payload ? JSON.stringify(res?.data?.login_payload) : ""};
                setLoading(false);
            } else {
                Helper.alert(res?.data?.message, 'error')
            }
        }).catch((res) => { 
            getPopupMessageBasedOnStatus(res) 
            setLoading(false)
        })
    }
 
    const AppMasterFormsDetailView = () => { 
        let textBoxInputSettings = [
            {
                className: "col-lg-4",
                label: "App name",
                inputType: "text",
                id: "app_name",
                required: true,
                name: "app_name",
            },
            {
                className: "col-lg-4",
                label: "App description",
                inputType: "text",
                required: true,
                id: "app_description",
                name: "app_description",
            },
            {
                className: "col-lg-4",
                label: "Base URL",
                inputType: "text",
                required: true,
                id: "base_url",
                name: "base_url",
            }, 
            {
                className: "col-lg-4",
                label: "Login payload",
                inputType: "textarea",
                id: "login_payload",
                name: "login_payload",
                required: true
            },
            {
                className: "col-lg-4",
                label: "Status",
                inputType: "dropdown",
                options: Settings.enumStatus,
                id: "status",
                name: "status",
                required: true,
            },
        ];
  
        return (
            <Collapse open={true} title={"General"}>
                <div className='row mb-3'>
                    <FieldsRenderer fieldsArray={textBoxInputSettings} updateState={setAppMasterFormsData} currentState={appMasterFormsData} />
                </div>
            </Collapse>
        )
    }
    
    const SaveHandler = () => {
        if(!areObjectsDifferent(defaultAppMasterFormsObject, appMasterFormsData)) return;
        
        let validData = {
            ...appMasterFormsData
        };

        if(!validator.isValid(validData)){
            validator.displayMessage();
            validator.reset() 
            return;
        };

        if (!appMasterFormsData.status && appMasterFormsData.status !== 0) {
            Helper.alert('Status field is required', 'error');
            return;
        };

        let api = Api;
        api.setUserToken();

        const apiPayload = getOnlyChangedValuesForApiPayload({
            newData: {
                ...appMasterFormsData,
                login_payload: JSON.parse(appMasterFormsData?.login_payload || '{}')
            },
            originalData: {
                ...defaultAppMasterFormsObject,
                login_payload: JSON.parse(defaultAppMasterFormsObject?.login_payload || '{}')
            }
        });
        
        api.axios().put(Settings.apiAppUrl+`/update/${id}/`, apiPayload).then(function(res){
            if(res?.status === 200){
                Helper.alert(res?.data?.message || 'App master updated successfully', 'success');
                getAppMasterFormsById();
            } else {
                Helper.alert(res?.data?.message, 'error')
            }
        }).catch((res) => {
            getPopupMessageBasedOnStatus(res);
        })
    }

    return ( 
        <div className='container-fluid'>
            <NavigationHeder title={ `<span style="color:#000;"> Edit App Master #</span> ${appMasterFormsData?.app_name}` }>
                <LinkBtn to={-1} isActive= {false} title={"Close"} />
                <Button isActive= {true} onClick ={SaveHandler} title={"Save"} icon={'/images/icons/save-white.svg'} />
            </NavigationHeder>
     
            {loading ? <SimpleLoading /> : (
                <Fragment>
                    {AppMasterFormsDetailView()} 
                </Fragment>
            )} 
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth
    }
}
   
export default connect(mapStateToProps) (MasterComponentWraper(AppMasterFormsDetailView));